import { render } from "./ClassesList.vue?vue&type=template&id=be6b8252&scoped=true"
import script from "./ClassesList.vue?vue&type=script&lang=js"
export * from "./ClassesList.vue?vue&type=script&lang=js"

import "./ClassesList.vue?vue&type=style&index=0&id=be6b8252&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be6b8252"]])

export default __exports__